import PropTypes from 'prop-types';
import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Popover from 'material-ui/Popover';
import MonthElement from './comp/monthElement/MonthElement';
import { MONTHS } from './helpers/monthPickerConstants';
import './monthPicker.scss';

const currentYear = new Date().getFullYear();

class MonthPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      defaultLabel: props.defaultLabel,
      years: Array(Math.abs(props.yearsBefore - props.yearsBeyond) + 1)
        .fill()
        .map((_, i) => (currentYear + props.yearsBeyond) - i),
      selectedMonths: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.month && !nextProps.month && this.props.year && !nextProps.year) {
      this.setState({ defaultLabel: this.props.defaultLabel });
    }
  }

  handleClick = event => {
    event.preventDefault();
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => this.setState({ open: false });

  handleSelectMonth = (row, month) => {
    const year = this.state.years[row];
    if (this.props.onChange) {
      this.props.onChange(year, month);
    }
    this.setState({
      open: false,
      selectedMonths: [{ month, year: row }],
      defaultLabel: `${year} - ${MONTHS[month]}`
    });
  };

  render() {
    const { years, startMonth, endMonth, selectedYear } = this.state;
    const { disabled, errorText } = this.props;
    return (
      <div>
        <FlatButton disabled={ disabled } onClick={ this.handleClick } className="month-picker__main-button">
          <div className="month-picker__main-button-label">{ this.state.defaultLabel }</div>
        </FlatButton>

        {
          errorText !== '' &&
          <span style={ { color: 'red', fontSize: '12px', display: errorText ? 'block' : 'hidden' } }>{ errorText }</span>
        }

        <Popover
          open={ this.state.open }
          anchorEl={ this.state.anchorEl }
          anchorOrigin={ { horizontal: 'left', vertical: 'bottom' } }
          targetOrigin={ { horizontal: 'left', vertical: 'top' } }
          onRequestClose={ this.handleRequestClose }
        >
          <div>
            <div className="month-picker__row">
              { years.map((year, i) => (
                <div key={ year }>
                  <button className="month-picker__button-year">{ year }</button>
                  { MONTHS.map((month, j) => (
                    <button key={ `${year}-${month}` } className="month-picker__button-month" onClick={ () => this.handleSelectMonth(i, j) }>
                      { (startMonth < j && endMonth > j) && selectedYear === years[i] && <div className="month-picker__selected-month" /> }
                      <MonthElement
                        month={ month }
                        selectedMonth={ this.props.month === month && this.props.year === year }
                      />
                    </button>
                  )) }
                </div>
              )) }
            </div>
          </div>
        </Popover>
      </div>
    );
  }
}

MonthPicker.propTypes = {
  month: PropTypes.string,
  year: PropTypes.number,
  disabled: PropTypes.bool,
  defaultLabel: PropTypes.string.isRequired,
  muiTheme: PropTypes.object,
  input: PropTypes.object,
  onChange: PropTypes.func,
  yearsBeyond: PropTypes.number,
  yearsBefore: PropTypes.number,
  errorText: PropTypes.string
};

MonthPicker.defaultProps = {
  yearsBeyond: 1,
  yearsBefore: 1,
  disabled: false,
  errorText: ''
};

export default MonthPicker;




// WEBPACK FOOTER //
// ./src/shared/components/monthPicker/MonthPicker.js